import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ToggleButton from 'vue-js-toggle-button'
import VModal from "vue-js-modal"
import { BootstrapVue } from 'bootstrap-vue'
import '@/assets/css/skeleton-only.css'
import moment from "moment";
import VueMoment from 'vue-moment'
import assetImport from './Utils/asset-import';
import VueMarkdown from 'vue-markdown'
import { setupAxiosInterceptor } from './Utils/axios-interceptor';
import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowRightFromBracket, faQuestion, faListCheck, faUsers, faUser, faSearch, faBookmark, faArchive, faRectangleList, faBan, faCheckToSlot,
  faPlusCircle, faPlusSquare, faEdit, faTrash, faCheck, faSearchPlus, faArrowUp, faChartSimple, faCircle, faPen, faClock, faArrowLeft, faArrowRight, faDeleteLeft, faBookOpenReader, faTag, faFilePen, faPenToSquare, faSwatchbook
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {  } from "@fortawesome/free-regular-svg-icons";
import VueToastr from 'vue-toastr';
import { ModalPlugin } from 'bootstrap-vue'

Vue.use(ModalPlugin);
Vue.use(VueMarkdown);

Vue.use(VueToastr);
library.add(
  faQuestion, faUsers, faUser, faSearch, faBookmark, faArrowRightFromBracket, faArchive, faRectangleList, faDeleteLeft, faBan, faCheckToSlot,
  faPlusCircle, faPlusSquare, faEdit, faTrash, faCheck, faSearchPlus, faArrowUp, faChartSimple, faCircle, faPen, faClock, faArrowLeft, faArrowRight, faBookOpenReader, faTag, faFilePen, faPenToSquare, faSwatchbook
)
library.add(faListCheck)
Vue.component('font-awesome-icon', FontAwesomeIcon)
import VueMathjax from 'vue-mathjax'

Vue.use(VueMathjax)

Vue.config.productionTip = false;
Vue.use(VModal);
Vue.use(BootstrapVue)
Vue.use(ToggleButton)

Vue.use(VueMoment, { moment });

// Configurar interceptor de axios para reemplazar localhost en Android
setupAxiosInterceptor();

// add asset import as global property to Vue.
Vue.prototype.$assetImport = assetImport;

// Configurar listener para deep links (esquema personalizado) en móvil
if (Capacitor.isNativePlatform()) {
  // Listener para cuando la app se abre con un deep link
  CapacitorApp.addListener('appUrlOpen', (data) => {
    console.log('[App] Deep link recibido:', data.url);
    
    // Parsear la URL del deep link
    // Ejemplo: com.mobius.app://oauth2/redirect?token=eyJhbGci...
    try {
      const url = new URL(data.url);
      
      // Verificar que sea nuestro esquema personalizado
      if (url.protocol === 'com.mobius.app:' && url.hostname === 'oauth2' && url.pathname === '/redirect') {
        console.log('[App] Deep link OAuth detectado, navegando a /oauth2/redirect');
        
        // Extraer parámetros de la URL
        const params = new URLSearchParams(url.search);
        const token = params.get('token');
        const error = params.get('error');
        
        // Navegar a la ruta de OAuth con los parámetros
        const query = {};
        if (token) {
          query.token = token;
          console.log('[App] Token encontrado en deep link');
        }
        if (error) {
          query.error = error;
          console.log('[App] Error encontrado en deep link:', error);
        }
        
        // Navegar a la ruta de OAuth
        router.push({
          path: '/oauth2/redirect',
          query: query
        }).catch(err => {
          // Ignorar errores de navegación duplicada
          if (err.name !== 'NavigationDuplicated') {
            console.error('[App] Error navegando a /oauth2/redirect:', err);
          }
        });
      } else {
        console.log('[App] Deep link ignorado (no es OAuth):', data.url);
      }
    } catch (error) {
      console.error('[App] Error parseando deep link:', error, data.url);
    }
  });
  
  // También manejar cuando la app se abre desde un estado cerrado
  CapacitorApp.addListener('appStateChange', ({ isActive }) => {
    if (isActive) {
      console.log('[App] App activada, verificando deep links pendientes');
    }
  });
  
  console.log('[App] Listeners de deep links configurados');
}

new Vue({
  router,
  store,
  beforeCreate() {
    this.$store.dispatch("auth/initialise");
  },
  render: (h) => h(App),
}).$mount("#app");
